<template lang="pug">
  .loading(:style="'height: ' + height + 'px; line-height: ' + height + 'px;'" data-testid="loading")
    i.fa.fa-spinner.fa-pulse.fa-fw(:class="faSize")
</template>

<script>
export default {
  name: 'Loading',
  props: {
    height: {type: Number, required: false, default: 450},
    faSize: {type: String, required: false, default: 'fa-3x'}
  }
}
</script>

<style scoped>
.loading {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/Loading.vue